export default "__VITE_ASSET__BQOqC7Ss__"